/* MetaSync v2 — interactions */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

  /* progress bar */
  var prog = document.querySelector('.m2-progress i');
  if (prog) {
    var onScroll = function () {
      var h = document.documentElement, p = h.scrollHeight - h.clientHeight;
      prog.style.width = (p > 0 ? Math.min(100, h.scrollTop / p * 100) : 0) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* header drawer */
  var burger = document.querySelector('.m2-burger'), drawer = document.querySelector('.m2-drawer');
  if (burger && drawer) {
    var close = function () { drawer.classList.remove('open'); document.body.classList.remove('m2-menu-open'); burger.setAttribute('aria-expanded', 'false'); };
    burger.addEventListener('click', function () {
      var open = !drawer.classList.contains('open');
      drawer.classList.toggle('open', open); document.body.classList.toggle('m2-menu-open', open); burger.setAttribute('aria-expanded', String(open));
    });
    drawer.querySelectorAll('a, .m2-drawer__close').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* hero chat loop */
  document.querySelectorAll('[data-m2-chat]').forEach(function (box) {
    var data;
    try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    if (!data || !data.length) return;
    var list = box.querySelector('.m2-phone__msgs'), typing = box.querySelector('.m2-typing'), n = 2, t;
    function render() {
      list.innerHTML = '';
      data.slice(0, n).forEach(function (m) {
        var d = document.createElement('div'); d.className = 'm2-msg ' + (m.from === 'user' ? 'user' : 'bot');
        d.textContent = m.text; var tm = document.createElement('time'); tm.textContent = m.time || ''; d.appendChild(tm); list.appendChild(d);
      });
    }
    function tick() {
      if (reduce) { n = data.length; render(); return; }
      if (n >= data.length) { t = setTimeout(function () { n = 2; typing.classList.remove('on'); render(); tick(); }, 5200); return; }
      if (data[n].from !== 'user') {
        typing.classList.add('on');
        t = setTimeout(function () { typing.classList.remove('on'); n++; render(); tick(); }, 1500);
      } else {
        t = setTimeout(function () { n++; render(); tick(); }, 1300);
      }
    }
    render(); tick();
  });

  /* sync rhythms tabs */
  document.querySelectorAll('[data-m2-sync]').forEach(function (sec) {
    var btns = sec.querySelectorAll('.m2-rh'), panes = sec.querySelectorAll('.m2-sync__pane');
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, k) { x.classList.toggle('on', k === i); x.setAttribute('aria-selected', String(k === i)); });
        panes.forEach(function (p, k) { p.classList.toggle('on', k === i); });
        if (window.innerWidth <= 900) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    });
  });

  /* day timeline */
  document.querySelectorAll('[data-m2-day]').forEach(function (sec) {
    var items = sec.querySelectorAll('.m2-mo'), stage = sec.querySelector('.m2-day__stage');
    if (!items.length || !stage) return;
    var tTime = stage.querySelector('.m2-day__time span'), bar = stage.querySelector('.m2-day__bar i'), rail = sec.querySelector('.m2-day__railfill'),
        h3 = stage.querySelector('.m2-day__txt h3'), p = stage.querySelector('.m2-day__txt p'), med = stage.querySelector('.m2-day__medtxt'),
        glow = stage.querySelector('.m2-day__glow'), img = stage.querySelector('.m2-day__media img'), vid = stage.querySelector('.m2-day__media video');
    function pick(i, scroll) {
      items.forEach(function (x, k) { x.classList.toggle('on', k === i); });
      var d = items[i].querySelector('.m2-mo__data');
      var g = function (n) { var e = d && d.querySelector('[data-' + n + ']'); return e ? e.getAttribute('data-' + n) : ''; };
      var pct = Math.round((i + 1) / items.length * 100);
      if (tTime) tTime.textContent = g('time');
      if (h3) h3.textContent = g('title');
      if (p) p.textContent = g('body');
      if (med) med.innerHTML = (g('media') || '').replace(/\n/g, '<br>');
      if (glow) glow.style.setProperty('--glow', g('glow') || 'rgba(200,144,86,.3)');
      if (bar) bar.style.width = pct + '%';
      if (rail) rail.style.height = pct + '%';
      var src = g('image');
      if (img) { if (src) { img.src = src; img.style.display = ''; if (med) med.style.display = 'none'; } else { img.style.display = 'none'; if (med) med.style.display = ''; } }
      var vs = g('video');
      if (vid) { if (vs) { if (vid.getAttribute('src') !== vs) vid.src = vs; vid.style.display = ''; vid.play && vid.play().catch(function () {}); if (med) med.style.display = 'none'; } else { vid.pause && vid.pause(); vid.style.display = 'none'; } }
      if (scroll && window.innerWidth <= 900) stage.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    items.forEach(function (b, i) { b.addEventListener('click', function () { pick(i, true); }); });
    pick(0, false);
  });

  /* stories: play video if present */
  document.querySelectorAll('.m2-story').forEach(function (s) {
    var v = s.querySelector('video'); if (!v) return;
    s.addEventListener('click', function () { if (v.paused) { v.play(); s.classList.add('playing'); } else { v.pause(); s.classList.remove('playing'); } });
  });
})();

/* accessibility widget */
(function () {
  'use strict';
  var wrap = document.querySelector('.m2-a11y'); if (!wrap) return;
  var btn = wrap.querySelector('.m2-a11y__btn'), panel = wrap.querySelector('.m2-a11y__panel');
  var KEY = 'ms2-a11y', modes = ['bigtext', 'contrast', 'grayscale', 'links', 'motion'];
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(st) { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function apply(st) {
    modes.forEach(function (m) {
      document.documentElement.classList.toggle('a11y-' + m, !!st[m]);
      var b = panel.querySelector('[data-a11y="' + m + '"]'); if (b) b.classList.toggle('on', !!st[m]);
    });
  }
  var state = load(); apply(state);
  btn.addEventListener('click', function () {
    var open = panel.hidden; panel.hidden = !open; btn.setAttribute('aria-expanded', String(open));
  });
  wrap.querySelector('.m2-a11y__close').addEventListener('click', function () { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); });
  panel.querySelectorAll('[data-a11y]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = b.dataset.a11y;
      if (m === 'reset') { state = {}; } else { state[m] = !state[m]; }
      save(state); apply(state);
    });
  });
  document.addEventListener('click', function (e) { if (!wrap.contains(e.target) && !panel.hidden) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
})();

/* mobile sync story-dots */
(function () {
  'use strict';
  if (window.innerWidth > 900) return;
  document.querySelectorAll('[data-m2-sync]').forEach(function (sec) {
    var panel = sec.querySelector('.m2-sync__panel'); if (!panel) return;
    var panes = panel.querySelectorAll('.m2-sync__pane'); if (panes.length < 2) return;
    var dots = document.createElement('div'); dots.className = 'm2-sync__dots';
    panes.forEach(function (_, i) { var d = document.createElement('i'); if (i === 0) d.className = 'on'; dots.appendChild(d); });
    panel.after(dots);
    var hint = document.createElement('div'); hint.className = 'm2-sync__hint'; hint.textContent = 'החליקי לצדדים ←'; dots.after(hint);
    var t;
    panel.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var mid = panel.scrollLeft + panel.clientWidth / 2, best = 0, bd = 1e9;
        panes.forEach(function (p, i) { var c = p.offsetLeft + p.offsetWidth / 2, d = Math.abs(c - mid); if (d < bd) { bd = d; best = i; } });
        dots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('on', i === best); });
        if (hint) { hint.remove(); hint = null; }
      }, 80);
    }, { passive: true });
  });
})();